import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { HardDrive } from 'lucide-react';
import api from '../../utils/api';

export const meta = {
  id: 'backup_status',
  category: 'system',
  titleKey: 'dashboard.widgets.backupStatus',
  descriptionKey: 'dashboard.widgets.backupStatusDesc',
  defaultSize: 'sm',
  requiresModule: 'backup_monitor',
  icon: HardDrive,
};

export default function BackupStatusWidget() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: stats } = useQuery({
    queryKey: ['backup-monitor-stats'],
    queryFn: () => api.get('/backup-monitor/stats').then(r => r.data),
    refetchInterval: 5 * 60 * 1000,
  });

  const total = parseInt(stats?.total) || 0;
  const critical = parseInt(stats?.critical) || 0;
  const warning = parseInt(stats?.warning) || 0;
  const ok = parseInt(stats?.ok) || 0;
  const unknown = parseInt(stats?.unknown) || 0;

  return (
    <div className="card" style={{ cursor: 'pointer', height: '100%' }} onClick={() => navigate('/backup-monitor')}>
      <div className="card-header">
        <div className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <HardDrive size={16} />
          {t('dashboard.widgets.backupStatus')}
        </div>
      </div>
      {total === 0 ? (
        <div style={{ padding: 24, textAlign: 'center', color: 'var(--c-text-muted)', fontSize: 13 }}>—</div>
      ) : (
        <div style={{ padding: '12px 20px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {critical > 0 && <BackupRow color="#ef4444" label={t('dashboard.widgets.backupCritical', 'Critical')} value={critical} />}
          {warning > 0 && <BackupRow color="#f59e0b" label={t('dashboard.widgets.backupWarning', 'Warning')} value={warning} />}
          <BackupRow color="#22c55e" label={t('dashboard.widgets.backupOk', 'OK')} value={ok} />
          {unknown > 0 && <BackupRow color="#6b7280" label={t('dashboard.widgets.backupUnknown', 'Unknown')} value={unknown} />}
          <div style={{ borderTop: '1px solid var(--c-border)', paddingTop: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 12, color: 'var(--c-text-muted)' }}>{t('dashboard.widgets.backupTotal', 'Total jobs')}</span>
            <span style={{ fontSize: 14, fontWeight: 600 }}>{total}</span>
          </div>
        </div>
      )}
    </div>
  );
}

function BackupRow({ color, label, value }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{ width: 10, height: 10, borderRadius: '50%', background: color, flexShrink: 0 }} />
      <span style={{ fontSize: 13, flex: 1 }}>{label}</span>
      <span style={{ fontSize: 18, fontWeight: 700, color }}>{value}</span>
    </div>
  );
}
